$(document).ready(function(){if(0!=$("#Promo_box").length){var o={promoBox:$("#Promo_box"),promoBoxdata:$(".promo_box_data"),promoboxclose:$(".promo_close"),init:function(){setTimeout(o.Promoboxinit(),3e3)},Promoboxinit:function(){if(991>$(window).width)return!1;o.SetPromoData(o.promoBox,o.promoBoxdata),o.ShowPromoBox(o.promoBox,o.promoBox.data("start")),o.ShowPromoBoxNext(o.promoBox,o.promoBoxdata,o.promoboxclose),o.promoboxclose.click(function(){o.promoBox.removeClass("newevent")})},SetPromoData:function(t,a){var r=o.GetPromoIndex(a),n=a.children().eq(r);t.find(".promo_url").attr("href",n.data("url")),t.find(".promo_img").find("img").attr("src",n.data("image")).attr("alt",n.data("alt")),t.find(".promo_name").text(n.data("name")),t.find(".promo_p").text(n.data("p"));var e=parseInt(n.data("min")),m=parseInt(n.data("max")),i=Math.floor(Math.random()*(m-e))+e;if(t.find(".info_value").text(i),void 0===n.data("text"))return!1;var d=n.data("text").split("||");r=Math.floor(Math.random()*(d.length-1))+0;t.find(".info_text").text(d[r])},ShowPromoBox:function(o,t){setTimeout(function(){o.addClass("newevent")},t)},GetPromoIndex:function(){var t=o.promoBoxdata.children().length;return Math.floor(Math.random()*(t-0))+0},ShowPromoBoxNext:function(t,a,r){var n=t.data("min"),e=t.data("max"),m=Math.floor(Math.random()*(e-n))+n;setTimeout(function(){r.trigger("click"),setTimeout(function(){o.SetPromoData(t,a),o.ShowPromoBox(t,0),o.ShowPromoBoxNext(t,a,r)},2e3)},m)}};o.init()}});

// Change product name styling on card headings
$(document).ready(function() {
  $('.card__heading a').each(function() {
    var heading = $(this);
    var text = heading.text().trim();
    var firstPart = '';
    var secondPart = '';

    // Check if "discovery pack" is present in the text
    var discoveryPackIndex = text.toLowerCase().indexOf("discovery pack");

    if (discoveryPackIndex !== -1) {
      firstPart = text.slice(0, discoveryPackIndex + "discovery pack".length).trim();
      secondPart = text.slice(discoveryPackIndex + "discovery pack".length).trim();
    } else {
      // If "discovery pack" is not found, use the original splitting logic
      var productNames = ["natural deodorant", "lip balm", "whipped tallow balm"];
      for (var i = 0; i < productNames.length; i++) {
        var productName = productNames[i];
        if (text.toLowerCase().indexOf(productName) !== -1) {
          var index = text.toLowerCase().indexOf(productName);
          firstPart = text.slice(0, index + productName.length).trim();
          secondPart = text.slice(index + productName.length).trim();
          break;
        }
      }
    }

    // Displaying the first and second parts
    if (firstPart && secondPart) {
      heading.html(firstPart + '<br>' + secondPart);
    }
  });
});